// extracted by mini-css-extract-plugin
export var actionText = "_oi-4";
export var container = "_oi-0";
export var leftSection = "_oi-1";
export var rightSection = "_oi-2";
export var settingsButton = "_oi-6";
export var settingsIcon = "_oi-7";
export var shortcut = "_oi-5";
export var shortcutGroup = "_oi-3";